import { Gamepad2 } from "lucide-react";
import { useBrand } from "@/context/BrandContext";

/**
 * Reusable brand identity block (logo + name).
 * Renders custom logo image if uploaded, else Gamepad2 icon.
 * Splits brand_name by "." to keep the two-tone style (e.g. RENTAL.PS).
 */
export default function BrandLogo({ size = "md", showSubtitle = true, subtitle = "Zone" }) {
  const { brand_name, brand_logo_base64 } = useBrand();

  const sizeMap = {
    sm: { box: "w-8 h-8", icon: 16, text: "text-sm", sub: "text-[9px]" },
    md: { box: "w-10 h-10", icon: 20, text: "text-lg", sub: "text-[10px]" },
    lg: { box: "w-12 h-12", icon: 24, text: "text-2xl", sub: "text-[10px]" },
  };
  const cfg = sizeMap[size] || sizeMap.md;

  // Split brand name on the LAST "." to two-tone style
  const name = brand_name || "RENTAL.PS";
  const dotIdx = name.lastIndexOf(".");
  let head = name;
  let tail = "";
  if (dotIdx > 0 && dotIdx < name.length - 1) {
    head = name.substring(0, dotIdx);
    tail = name.substring(dotIdx); // includes the dot
  }

  return (
    <div className="flex items-center gap-3 group">
      <div className={`${cfg.box} flex items-center justify-center bg-[#00E5FF] text-black neon-glow overflow-hidden`}>
        {brand_logo_base64 ? (
          <img src={brand_logo_base64} alt={name} className="w-full h-full object-cover" />
        ) : (
          <Gamepad2 size={cfg.icon} strokeWidth={2.5} />
        )}
      </div>
      <div>
        <div className={`font-heading font-black text-white ${cfg.text} leading-none tracking-tight`}>
          {head}
          {tail && <span className="text-[#00E5FF]">{tail}</span>}
        </div>
        {showSubtitle && (
          <div className={`${cfg.sub} uppercase tracking-[0.3em] text-gray-500 mt-1`}>{subtitle}</div>
        )}
      </div>
    </div>
  );
}
